export class Linechart {
  title: string;
  linechartLabels: string[] = [];
  linechartData: any[] = [];
  linechartColors: any[] = [];
  lineChartOptions: any;
  lineChartLegend: boolean;
  lineChartType: string;
}
